import React, { useState } from "react";
import axiosInstance from "../services/axiosComman";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";

function useAddData() {
  const [isCreateLoading, setIsCreateLoading] = useState(false);
  const queryClient = useQueryClient();
  const addData = async ({
    url,
    value,
    resetForm = () => {},
    onClose = () => {},
    getData = () => {},
    hasFile = false,
    setSelectedFile = () => {},
    otherFunction = () => {},
    customMsg = "",
  }) => {
    setIsCreateLoading(true);
    console.log(url, value);

    try {
      const res = await axiosInstance.post(url, value);

      if (
        res.data?.status === true ||
        res.data?.msg === "Data Added Successfully"
      ) {
        resetForm();
        getData();
        onClose();
        if (hasFile) setSelectedFile(null);

        toast.success(
          <p className="test-sm">
            {customMsg ||
              res.data.msg ||
              res.data.message ||
              "Data Added Successfully"}
          </p>
        );

        queryClient.invalidateQueries({ queryKey: ["alerts"] });

        otherFunction();
      } else {
        toast.error(
          <p className="test-sm">
            {res.data?.msg ||
              res.data?.message ||
              res.data?.error ||
              "Data Added Unsuccessfully"}
          </p>
        );
      }
    } catch (err) {
      const apiMsg =
        err?.response?.data?.msg ||
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "Data Added Unsuccessfully";

      toast.error(<p className="test-sm">{apiMsg}</p>);
    } finally {
      setIsCreateLoading(false);
    }
  };
  return { isCreateLoading, addData };
}

export default useAddData;
